import _ from 'lodash';

/* @ngInject */
export default function TripWireModalController(
  $scope,
  $uibModalInstance,
  $filter,
  $log,
  tripWire,
  TripWireService,
  EventInfoService
) {
  const vm = this;

  /**
   * public variables
   */
  vm.currentTripwire = tripWire;
  vm.events = [];
  vm.loaded = false;
  vm.selectedEvent = false;
  vm.selectedEventIndex = 0;
  vm.viewBy = 10;
  vm.currentPage = 1;
  vm.maxSize = 5;
  vm.reverse = true;
  vm.columnSorted = 'eventDate';

  /**
   * Public functions
   */
  vm.dismiss = dismiss;
  vm.viewDetails = viewDetails;
  vm.closeEventViewer = closeEventViewer;
  vm.isFirstEvent = isFirstEvent;
  vm.isLastEvent = isLastEvent;
  vm.viewPreviousEvent = viewPreviousEvent;
  vm.viewNextEvent = viewNextEvent;
  vm.close = close;
  vm.flagThisEvent = flagThisEvent;
  vm.setPage = setPage;
  vm.sortBy = sortBy;
  vm.playStates = {};

  getEventsDetailed()
    .then((results) => {
      vm.events = results;
      vm.loaded = true;
      vm.sortBy(vm.columnSorted, vm.reverse);

      // watch for future changes
      $scope.$on(`event:${tripWire.equipment.id}`, (__, eventObj) => {
        const now = new Date();
        if (new Date(eventObj.eventDate) < now.setDate(now.getDate() - 1)) {
          return; // ignore events older than 1 day
        }
        vm.events.push(eventObj);
        sortBy(vm.columnSorted, vm.reverse);
      });
      vm.loaded = true; // stop loading spinner
    });

  function dismiss(theEvent) {
    theEvent.dismissed = !theEvent.dismissed;

    EventInfoService.updateEvent(theEvent.id, {
      dismissed: theEvent.dismissed
    })
      .then(() => {
        // Broadcast the event update to ensure all components are in sync
        // Add more detail to help event panel recognize this is a tripwire event
        const updatedEvent = {
          ...theEvent,
          _source: 'tripwirePanel' // Add a source marker
        };
        $scope.$root.$broadcast('event:updated', updatedEvent);
      })
      .catch(() => {
        theEvent.dismissed = !theEvent.dismissed;
      });
  }

  function viewDetails(event) {
    const index = _.findIndex(vm.events, eve => eve.id === event.id);
    if (index >= 0) {
      vm.selectedEvent = vm.events[index];
      vm.selectedEventIndex = index;
    } else {
      $log.error('index not in events');
    }
  }

  function closeEventViewer() {
    vm.selectedEvent = false;
    vm.selectedEventIndex = 0;
  }

  function isFirstEvent() {
    return (vm.selectedEventIndex - 1) < 0;
  }

  function isLastEvent() {
    return (vm.selectedEventIndex + 1) > (vm.events.length - 1);
  }

  function viewPreviousEvent() {
    if (!vm.isLastEvent()) {
      vm.selectedEventIndex += 1;
      vm.selectedEvent = vm.events[vm.selectedEventIndex];
    }
  }

  function viewNextEvent() {
    if (!vm.isFirstEvent()) {
      vm.selectedEventIndex -= 1;
      vm.selectedEvent = vm.events[vm.selectedEventIndex];
    }
  }

  /*
     * closes modal and send back the new number of undismissed events
     */
  function close() {
    let count = 0;
    if (vm.loaded) {
      _.each(vm.events, (eve) => {
        if (!eve.dismissed) {
          count += 1;
        }
      });
    }
    $uibModalInstance.close(count);
  }

  function flagThisEvent(theEvent) {
    theEvent.flagged = !theEvent.flagged;

    EventInfoService.updateEvent(theEvent.id, {
      flagged: theEvent.flagged
    })
      .catch(() => {
        theEvent.flagged = !theEvent.flagged;
      });
  }

  function setPage(pageNumber) {
    vm.currentPage = pageNumber;
  }

  function sortBy(predicate, reverse) {
    vm.events = $filter('orderBy')(vm.events, predicate, reverse);
    vm.columnSorted = predicate;
  }

  /**
   * private variables
   */

  /*
     * private funtions
     */
  function getEventsDetailed() {
    return TripWireService.getEventsDetailed(tripWire.equipment.id)
      .then(results => results.data);
  }
}
